import { render, staticRenderFns } from "./TrackLink.vue?vue&type=template&id=1820836e&"
import script from "./TrackLink.vue?vue&type=script&lang=js&"
export * from "./TrackLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports